<script setup lang="ts">
import { computed } from 'vue'
import { useVaultStore } from '../../stores/vault'

defineProps<{ selected: string }>()
const emit = defineEmits<{ select: [id: string] }>()

const vault = useVaultStore()
const sorted = computed(() => [...vault.people].sort((a, b) => b.close - a.close))
</script>

<template>
  <div class="plist">
    <button
      v-for="(p, i) in sorted"
      :key="p.id"
      class="prow"
      :class="{ sel: p.id === selected }"
      @click="emit('select', p.id)"
    >
      <div class="av" :style="{ '--c1': p.c1, '--c2': p.c2, '--dl': `${-i * 1.1}s` }"></div>
      <div class="tx"><b>{{ p.name }}</b><span>{{ p.title }}</span></div>
      <div class="close" title="나와의 거리"><i :style="{ width: `${p.close * 100}%` }"></i></div>
    </button>
  </div>
</template>
